import { useCallback, useEffect, useState } from "react";
import { agentApi } from "../services/api";

const MAX_PAGES = 20;

/** Every agent, active first — follows pagination to exhaustion. */
const useAgents = () => {
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAgents = useCallback(async ({ background = false } = {}) => {
    if (!background) setLoading(true);
    setError(null);
    try {
      const all = [];
      let page = 1;
      for (;;) {
        const { data } = await agentApi.list({ page });
        all.push(...(Array.isArray(data) ? data : data?.results || []));
        if (!data?.next || page >= MAX_PAGES) break;
        page += 1;
      }
      setAgents(all);
    } catch (err) {
      setError(err);
    } finally {
      if (!background) setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAgents();
  }, [fetchAgents]);

  return { agents, loading, error, refresh: fetchAgents };
};

export default useAgents;
